export const binarySearch = <T, K>(
    arr: T[],
    val: K,
    accesor: (arg0: T) => K,
    comparatorFn: (arg0: K, arg1: K) => number
) => {
    let start = 0;
    let end = arr.length - 1;

    while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        const resultOfCompare = comparatorFn(val, accesor(arr[mid]));

        if (resultOfCompare === 0) {
            return mid;
        }

        if (resultOfCompare < 0) {
            end = mid - 1;
        } else {
            start = mid + 1;
        }
    }
    return -1;
};

export const findClosestByBinarySearch = <T>(
    arr: T[],
    targetValue: number,
    accessor: (item: T) => number
): T | undefined => {
    if (arr.length === 0) {
        return undefined;
    }
    if (arr.length === 1) {
        return arr[0];
    }

    // Determine if array is ascending or descending
    const isAscending = accessor(arr[0]) <= accessor(arr[arr.length - 1]);

    let left = 0;
    let right = arr.length - 1;

    while (left < right) {
        const mid = Math.floor((left + right) / 2);
        const midValue = accessor(arr[mid]);
        if (isAscending) {
            // Ascending order logic
            if (midValue < targetValue) {
                left = mid + 1;
            } else {
                right = mid;
            }
        } else {
            // Descending order logic
            if (midValue > targetValue) {
                left = mid + 1;
            } else {
                right = mid;
            }
        }
    }

    // Find the closest among potential candidates
    const candidates = [left];
    if (left > 0) {
        candidates.push(left - 1);
    }
    if (left < arr.length - 1) {
        candidates.push(left + 1);
    }

    let closest = arr[left];
    let minDiff = Math.abs(accessor(arr[left]) - targetValue);

    for (const index of candidates) {
        if (index >= 0 && index < arr.length) {
            const diff = Math.abs(accessor(arr[index]) - targetValue);
            if (diff < minDiff) {
                minDiff = diff;
                closest = arr[index];
            }
        }
    }

    return closest;
};
